<template>
    <div class="Reports__View">
        <EntityListLayout :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
            <template #title>היסטוריית יבוא</template>
            <template v-slot:counter="slotProps">
                סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
            </template>
        </EntityListLayout>
    </div>
</template>
<script>
import ReportService from "@/services/ReportService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import FieldService from "@/services/FieldService";
// import ProfileService from "@/services/ProfileService";
// import AdminUnmanagedReportEntity from "@/views/AdminUnmanagedReportEntity.vue";
// import TableActions from "@/services/TableActionsService";
// import VehicleService from "@/services/VehicleService";
// import FilterService from "@/services/FilterService";
// import NewReportEntity from "@/components/Entities/NewReportEntity.vue";
// import { saveAs } from "file-saver";

export default {
    name: "AdminSearchReports",
    data() {
        return {
            tabs: [],
        };
    },
    components: {
        EntityListLayout,
    },
    computed: {
        excelMimeType() {
            return "application/vnd.ms-excel";
        },
        isLeasingCompany() {
            return this.$store.state.profile?.IsLeasingCompany;
        },
        isReady() {
            return this.isLeasingCompany !== null;
        },
    },
    created() {
        this.create();
    },
    methods: {
        create() {
            const reportsFields = FieldService.list("batchReports");
            // const reportsfilters = FilterService.list();

            // const sideViewEntity = {
            //     component: AdminUnmanagedReportEntity,
            //     preview: true,
            //     readOnly: false,
            //     title: "פרטי דוח",
            //     recordUrl: "admin/reports",
            // };

            // const excelExport = [
            //     {
            //         title: "יצוא טבלה",
            //         action: this.export,
            //     },
            // ];
            const fields = [
                { ...reportsFields.BatchId, checked: true },
                { ...reportsFields.CreateDate, checked: true },
                { ...reportsFields.Status, checked: true },
                { ...reportsFields.HasErrors, checked: true },
                { ...reportsFields.Comment, checked: true },
                { ...reportsFields.ProfileId, checked: true },
                { ...reportsFields.DownloadFile, checked: true },
            ];

            const reportFields = [...fields];

            this.tabs = [
                {
                    id: "AdminBatchReports",
                    title: "כל ההיסטוריה",
                    // newEntityComponent: NewReportEntity,
                    getDataAsync: this.getBatchReports,
                    perPage: 20,
                    fields: reportFields,
                    // filters: [
                    //     { ...reportsfilters.IsPaid },
                    //     { ...reportsfilters.ReportStatus },
                    //     { ...reportsfilters.NotReportStatus },
                    //     { ...reportsfilters.Reason },
                    //     { ...reportsfilters.Alerts },
                    //     {
                    //         ...reportsfilters.Profile,
                    //         OptionsAsync: ProfileService.allMapped,
                    //         isTransferOnly: false
                    //     },
                    //     { ...reportsfilters.Driver },
                    //     {
                    //         ...reportsfilters.VehicleOwner,
                    //         OptionsAsync: ProfileService.allMapped,
                    //     },
                    //     { ...reportsfilters.TransferStatusWNotTransferred },
                    //     {
                    //         ...reportsfilters.DriverTransferStatusWNotTransferred,
                    //         Display: "סטטוס הסבת עובד",
                    //         Query: "DriverTransferStatus",
                    //         Tooltip: 'סטטוס ההסבה של עובד ע"פ המערכת',
                    //     },
                    //     { ...reportsfilters.ReportNumber },
                    //     { ...reportsfilters.PostOfficeReference },
                    //     {
                    //         ...reportsfilters.PlateNumber,
                    //         selected: this.$route.query.PlateNumber,
                    //         OptionsAsync: (term) =>
                    //             VehicleService.searchAdminPlateNumber(term).then((r) => {
                    //                 if (!r.data.length) return [{ Text: term, Value: term }];
                    //                 return r.data.map((s) => ({ Text: s.Name, Value: s.Name }));
                    //             }
                    //             ),
                    //     },
                    //     { ...reportsfilters.MuniIdNumber },
                    //     { ...reportsfilters.Municipality },
                    //     {
                    //         ...reportsfilters.DateTypes,
                    //         selected: FilterService.DateSearchTypes.DateTaken,
                    //         Options: this.isLeasingCompany
                    //             ? reportsfilters.DateTypes.Options
                    //             : [
                    //                 { ...FilterService.DateSearchTypes.DateTaken },
                    //                 { ...FilterService.DateSearchTypes.LastPayDate },
                    //                 { ...FilterService.DateSearchTypes.PaymentDate },
                    //                 { ...FilterService.DateSearchTypes.ApprovalDate },
                    //                 { ...FilterService.DateSearchTypes.VerificationDate },
                    //                 { ...FilterService.DateSearchTypes.CreateDate },
                    //                 {
                    //                     ...FilterService.DateSearchTypes
                    //                         .FirstDocumentTransferCompleteDate,
                    //                 },
                    //                 {
                    //                     ...FilterService.DateSearchTypes
                    //                         .FirstDocumentTransferDriverCompleteDate,
                    //                 },
                    //             ],
                    //     },
                    // ],
                    sortField: "LastPayDate",
                    sortOrder: "desc",
                    // checkableRows: true,
                },
            ];
        },
        onNewEntitySave() {
            this.$refs.entity.onNewEntityCancel();
        },
        // export({ loading, query }) {
        //     loading(true);
        //     ReportService.exportXslAdmin(query)
        //         .then((r) => {
        //             this.saveFile(r.data, "יצוא דוחות ממערכת Betterway");
        //         })
        //         .finally(() => {
        //             loading(false);
        //         });
        // },
        getBatchReports({ cancelToken, ...rest }) {
            return ReportService.getBatchReports(rest.PageNumber, rest.PageSize);
        },
        getTotalRecords(slotProps) {
            return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
        },
        // saveFile(data, filename) {
    },
    watch: {
        isReady(value) {
            if (value) {
                this.create();
            }
        },
    },
};
</script>
<style scoped>
.Reports__View {
    height: 100%;
}
</style>
